import React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import SelectValue from '../../../dict/simple/select/SelectValue';
import OptionComponent from '../../../dict/simple/select/DictOption';
import { updateDealPayment } from '../store/deal.store';
import UploadZone from '../files/UploadZone';
import { fromJS } from 'immutable';

class FileDocument extends React.Component {
  constructor(props) {
    super(props);
    this.setValue = this.setValue.bind(this);
    this.createData = this.createData.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onAddFile = this.onAddFile.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.state = {
      data: [],
      showModal: false,
    };
    this.value = props.payment ? props.payment.getIn(['document', 'uuid']) : undefined;
  }

  componentWillMount() {
    this.createData(this.props);
  }
  componentWillReceiveProps(props) {
    this.createData(props);
  }

  onChange(value) {
    const refValue = value instanceof Array ? value[value.length - 1] : value;
    if (refValue != null && refValue.value == -1) {
      this.setState({ showModal: true });
    } else {
      this.setValue(value);
    }
  }

  onAddFile(file) {
    this.setState({ showModal: false },
      () => {
        if (file) {
          const uuid = this.getUUID(file);
          const originalName = this.getName(file);
          this.setValue(
            {
              value: uuid,
              label: originalName,
              meta: {
                uuid,
                originalName,
                type: file.meta ? file.meta.type : undefined,
                regNumber: file.meta ? file.meta.regNumber : undefined,
              },
              hidden: false,
              disabled: false,
            });
        }
      });
  }

  getUUID(fileData) {
    const file = fileData.raw || fileData;
    if (file && file.meta && file.meta.uuid) {
      return file.meta.uuid;
    }
    if (file && file.file && file.file.preview) {
      const uuids = file.file.preview.split('/');
      return uuids[uuids.length - 1];
    }
    return undefined;
  }

  getName(fileData) {
    const file = fileData.raw || fileData;
    if (!file) {
      return undefined;
    }
    if (file.meta && file.meta.regNumber) {
      return file.meta.regNumber;
    }
    if (file.file && file.file.name) {
      return file.file.name;
    }
    if (file.meta && file.meta.originalName) {
      return file.meta.originalName;
    }
    return undefined;
  }

  setValue(value) {
    this.value = value;
    const valueToSet = value;
    if (valueToSet && !valueToSet.meta) {
      valueToSet.meta = { uuid: valueToSet.value };
    } else if (valueToSet && !valueToSet.meta.uuid) {
      valueToSet.meta.uuid = valueToSet.value;
    }
    this.props.updateDealPayment(
      this.props.payment.set('document', value ? fromJS(valueToSet.meta) : undefined)
    );
  }

  createData(props) {
    let data = [];

    if (props.files) {
      data = props.files.toJS().map((elem) => ({
        value: this.getUUID(elem),
        label: this.getName(elem),
        meta: elem.raw.meta,
        hidden: false,
        href: this.getUUID(elem) && elem && elem.raw && elem.raw.meta && elem.raw.meta.id ?
          `/download/api/${this.getUUID(elem)}` : undefined,
        disabled: false,
      }));
    }
    let clearSelection = false;
    let value = this.value;
    if (value) {
      value = data.find(d => d.value == value || d.value == value.value);
      if (!value) {
        clearSelection = true;
      }
    }
    data.unshift({
      value: -1,
      label: 'Add new item',
      hidden: false,
      disabled: false,
      style: { color: 'white', backgroundColor: '#008cba', margin: '5px 0' },
    });
    if (clearSelection) {
      this.setState({ data });
      this.value = null;
    } else {
      this.setState({ data });
      if (value) {
        this.value = value;
      }
    }
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  render() {
    return (<div>
      <UploadZone
        showModal={this.state.showModal}
        onClose={this.closeModal}
        type={this.props.type}
        onAddFile={this.onAddFile}
      />
      <Select
        valueComponent={SelectValue}
        optionComponent={OptionComponent}
        disabled={this.props.disabled}
        options={this.state.data}
        onChange={this.onChange}
        value={this.value}
        matchProp="label"
      />
    </div>);
  }
}

FileDocument.propTypes = {
  idx: React.PropTypes.number,
  payment: React.PropTypes.object,
  type: React.PropTypes.string,
  productIdx: React.PropTypes.number,
  paymentIdx: React.PropTypes.number,
  updateDealPayment: React.PropTypes.func,
  parentPaymentIdx: React.PropTypes.number,
  disabled: React.PropTypes.bool,
};

export default connect(
  (state, props) => {
    const paymentPath = props.dealType == 'transport' ?
      ['data', 'deals', 'deal', 'payments'] :
      ['data', 'deals', 'deal', 'products', props.productIdx, 'payments'];
    if (props.parentPaymentIdx !== undefined) {
      paymentPath.push(props.parentPaymentIdx);
      paymentPath.push('payments');
    }
    paymentPath.push(props.paymentIdx);
    return {
      payment: state.getIn(paymentPath),
      files: state.getIn(['data', 'deals', 'files', props.type]),
    };
  },
  (dispatch, props) => ({
    updateDealPayment(payment) {
      const paymentIdxs = [];
      if (props.parentPaymentIdx !== undefined) {
        paymentIdxs.push(props.parentPaymentIdx);
      }
      paymentIdxs.push(props.paymentIdx);
      updateDealPayment(dispatch, props.productIdx, paymentIdxs, payment);
    },
  })
)(FileDocument);
